import React from 'react';
import styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const headerText = StringConstantsMixin.strings.REDEMPTION_PAGE.REDEEM_YOUR_CARD;

const RedemptionHeader = () => {
  const cardsImage = 'https://cdn-assets.alltrails.com/assets/images/gifting/cards-pile@2x.png';

  return (
    <main className={styles.heroContainer}>
      <div className={styles.contentContainer}>
        <h1 className={styles.heroMessage} dangerouslySetInnerHTML={headerText} />
        <img className={styles.giftCards} src={cardsImage} alt="" />
      </div>
    </main>
  );
};

export default RedemptionHeader;
